// @flow
import type {
  User,
  UsersById,
} from 'fc-model-users/types'

// Libs
import _filter from 'lodash/filter'
import _get from 'lodash/get'
import _isEmpty from 'lodash/isEmpty'

// Controller
import controller from 'fc-ctrl-users'

// Constants
import { BRANCH } from './constants'

function receiveUsers (state: Object, res: Object = {}): Object {
  const receivedUsers: UsersById = res.data || {}
  const receivedUsersIds = Object.keys(receivedUsers)
  const existingUsersToBeUpdated = _filter(state[BRANCH], (user: User): boolean =>
    receivedUsersIds.indexOf(String(user.id)) > -1
  )

  // update emails - backwards compatibility before HEF-1180 (supports 2 formats)
  const updatedReceivedUsers = receivedUsersIds.reduce(
    (acc: Object, id: Object): UsersById => {
      const newUserInfo = receivedUsers[id]
      const userOldContacts = _get(newUserInfo, 'contacts', {})
      const email = _get(newUserInfo, 'email', null) || _get(userOldContacts, 'email.entry', '')
      const phone = _get(newUserInfo, 'phone', null) || _get(userOldContacts, 'phone.entry', '')

      return {
        ...acc,
        [id]: {
          ...newUserInfo,
          phone,
          email,
        },
      }
    }, {})

  // On init, only main user is updated. Subusers are excluded
  const updatedExistingUsers = existingUsersToBeUpdated.reduce(
    (acc: Object, cur: Object, i: number, users: Array): UsersById => {
      const currentUser = users[i]
      const id = currentUser.id
      const newUserInfo = receivedUsers[id]
      const newUserContacts = _get(receivedUsers[id], 'contacts', currentUser.contacts)
      const clientBillingAddress = _get(receivedUsers, `[${id}].clientBillingAddress`, undefined) ||
        currentUser.clientBillingAddress
      const roles = !_isEmpty(currentUser.roles) ? currentUser.roles : receivedUsers[id].roles
      // Backwards compatibility for HEF-1180
      const email = _get(newUserInfo, 'email', null) || _get(newUserContacts, 'email.entry', '')
      const phone = _get(newUserInfo, 'phone', null) || _get(newUserContacts, 'phone.entry', '')

      return {
        ...acc,
        [currentUser.id]: {
          ...newUserInfo,
          clientBillingAddress,
          roles,
          email,
          phone,
        },
      }
    }, {})

  return {
    ...state,
    [BRANCH]: {
      ...state[BRANCH],
      ...updatedReceivedUsers,
      ...updatedExistingUsers,
    },
  }
}

export default {
  [controller.actionTypes.receive()]: receiveUsers,
}
